import axios from 'axios';
import { IAssessmentHistoryCollectionDto, IAssessmentHistoryParams } from 'entities/PatientMetrics/PatientMetrics.models';

const basePath = '/patient-metrics';

export const patientMetricsService = {
  getAssessmentHistory: ({ patientId, offset, limit }: IAssessmentHistoryParams): Promise<IAssessmentHistoryCollectionDto> =>
    axios.get(`${basePath}/${patientId}/assessment-history`, { params: { offset, limit } }),
};
